import type { AvatarTone } from "@/types";
import { cn } from "@/lib/utils";

interface AvatarProps {
  src?: string;
  initials: string;
  size?: "sm" | "md" | "lg";
  tone?: AvatarTone;
  className?: string;
}

const sizeStyles = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

const toneStyles: Record<AvatarTone, string> = {
  amber: "bg-amber-100 text-amber-800",
  sky: "bg-sky-100 text-sky-800",
  blue: "bg-blue-100 text-blue-800",
  rose: "bg-rose-100 text-rose-800",
  violet: "bg-violet-100 text-violet-800",
  emerald: "bg-emerald-100 text-emerald-800",
  orange: "bg-orange-100 text-orange-800",
  slate: "bg-slate-200 text-slate-700",
};

export function Avatar({
  src,
  initials,
  size = "md",
  tone = "slate",
  className = "",
}: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt=""
        className={cn("rounded-full object-cover", sizeStyles[size], className)}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-medium",
        sizeStyles[size],
        toneStyles[tone],
        className,
      )}
    >
      {initials}
    </div>
  );
}
